var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "actions" }, [
    _vm.canPurchase
      ? _c(
          "a",
          {
            staticClass: "lib-button full-width",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function ($event) {
                return _vm.$emit("purchase")
              },
            },
          },
          [_vm._v("Subscribe Now")]
        )
      : _c("a", { attrs: { href: "/contact-us" } }, [_vm._v("Contact Us")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }